import Position from 'pages/path-finding-page/config/interfaces/Position';

function isSamePosition(position1: Position | null, position2: Position | null) {
  return position1 && position2 && position1.row === position2.row && position1.col === position2.col;
}

export default isSamePosition;
